module.exports = __webpack_public_path__ + "static/image/together/m/visual@3x.ver2_0_2.jpg?760c1ece";